export const GET_TOTAL_STATS = 'MISC_FEE_LP/get_total_stats';
export const GET_GRAPH_STATS = 'MISC_FEE_LP/get_graph_stats';

export const MISC_FEE_LP = [
  { name: 'WAITING FOR PAYMENT', color: '#5272AA', value: 0 },
  { name: 'PAID', color: '#A3B3F9', value: 0 },
];
